import React from "react";
import { Box, Typography } from "@mui/material";

interface StatusBadgeProps {
  variant: "active" | "pending" | "cancelled" | "completed" | "sent";
  label?: string;
}

export const formatStatusLabel = (value?: string): string => {
  if (!value) return "";
  return value
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const StatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Active" || status === "active" ? "#0E9F6E" : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};

export const LiveStatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Live" || status === "live" || status === "Locked"
            ? "#0E9F6E"
            : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};
export const CompletedStatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Completed" || status === "completed"
            ? "#0E9F6E"
            : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ variant, label }) => {
  const badges = {
    active: { background: "#DCFCE7", color: "#166534", border: "#BBF7D0" },
    sent: {
      background: "#DBEAFE",
      color: "#1E3A8A",
      border: "#BFDBFE",
    },
    pending: { background: "#FEF3C7", color: "#92400E", border: "#FDE68A" },
    cancelled: { background: "#FEE2E2", color: "#991B1B", border: "#FECACA" },
    completed: { background: "#F3F4F6", color: "#1F2937", border: "#E5E7EB" },
  };
  const formattedLabel = formatStatusLabel(label);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        p: "2px 8px",
        borderRadius: "99px",
        border: `1px solid ${badges?.[variant || "completed"].border}`,
        backgroundColor: badges?.[variant || "completed"].background,
        color: badges?.[variant || "completed"].color,
      }}
    >
      <Typography variant="caption" fontWeight={500}>
        {formattedLabel ?? variant.charAt(0).toUpperCase() + variant.slice(1)}
      </Typography>
    </Box>
  );
};
